import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface SetSurroundMaterialArgs {
	materialKey: string;
}

export const setSurroundMaterialTool = (blueprint: Blueprint, { materialKey }: SetSurroundMaterialArgs): ToolResult => {
	if (!materialKey) return { success: false, error: 'Missing materialKey. Use get_surround_material_options to get valid material keys.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	kitchen.material.setSurround(materialKey);
	return { success: true, message: `Surround material set to ${materialKey}.` };
};
